/**
 * @member {string} owner
 * @member {string} from
 * @member {string} to
 * @member {string} serialNumber
 * @member {string|null} position
 */
export class StepOneRequestDTO {
  constructor ({ algorithm, owner, from, to, number, position = null }) {
    let properties = {
      configurable: false,
      enumerable: true,
      writable: false
    }
    Object.defineProperty(this, 'algorithm', Object.assign({ value: algorithm }, properties));
    Object.defineProperty(this, 'owner', Object.assign({ value: owner }, properties));
    Object.defineProperty(this, 'from', Object.assign({ value: from }, properties));
    Object.defineProperty(this, 'to', Object.assign({ value: to }, properties));
    Object.defineProperty(this, 'number', Object.assign({ value: number }, properties));
    Object.defineProperty(this, 'position', Object.assign({ value: position }, properties));
    Object.freeze(this);
  }

  owner;

  from;

  to;

  number;

  position;
}
